/**
 * Created by andrewstirling on 20/6/17.
 */

import React, { Component } from 'react';
import CustomerLogins       from '../presentation/customer-logins';

export default class CustomerLoginsWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginList: [],
            showModal: false
        }
    }

    updateFormState = e => {
        let name = e.target.name;
        let value = e.target.value;
        if( name == "availableApplications" ) {
            value = [];
            let options = e.target.options;
            for (let i = 0, l = options.length; i < l; i++) {
                if (options[i].selected) {
                    value.push(options[i].value);
                }
            }
        }
        this.setState(prevState =>({
            formState: Object.assign({}, prevState.formState, {[name]: value})
        }));
    };

    componentWillMount() {
        this.refreshList();
        this.loadApplicationList();
    }

    refreshList = () => {
        fetch("/service/"+this.props.account._id+"/customerLogins", {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin'
        }).then(response => {
            if( response.status != 200 ) {
                response.json().then(json => {
                    this.handleError(json, this);
                    return;
                });
            } else {
                response.json().then(json => {
                    this.loadList(json);
                });
            }
        });
    };

    loadApplicationList = () => {
        fetch("/service/"+this.props.account._id+"/applications", {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin'
        }).then(response => {
            if( response.status != 200 ) {
                response.json().then(json => {
                    this.handleError(json, this);
                    return;
                });
            } else {
                response.json().then((json) => {
                    this.setState({applications: json});
                });
            }
        });
    };

    loadList = data => {
        this.setState({loginList: data});
    };

    resetForm = () => {
        this.setState({formState: {}});
    };

    render() {
        return (
            <CustomerLogins 
                account={this.props.account} 
                loginList={this.state.loginList} 
                loadData={this.state} 
                launchSSO={this.launchSSO}
            />
        )
    }
}
